import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'grid-select-render',
  template:
    "<select class=\"content {{params.selectClass != null ? params.selectClass : ''}}\" [(ngModel)]='selectedValue' (change)='onSelectChanged($event)'>"
    + "<option *ngFor='let o of params.dataSource' value='{{o.value}}'>{{o.name}}</option>"
    + "</select>",
  styleUrls: ['./grid-select-renderer.component.css']
})


export class GridSelectRendererComponent implements ICellRendererAngularComp {
  public params: any;
  public selectedValue = null;

  constructor() { }
  agInit(params: any): void {
    this.params = params;
    if (params.field != null)
      this.selectedValue = params.node.data[params.field];
    if (params.defaultValue != null)
      this.selectedValue = params.defaultValue;
  }

  onSelectChanged(): void {
    if (this.params.onSelectChanged instanceof Function) this.params.onSelectChanged(this.params.node, this.selectedValue);
    if (this.params.cellClass instanceof Function) {
      this.setClass(this.params.cellClass(this.params.node, this.selectedValue).join(' '));
    };
  }

  setClass(params): void {
    this.params.selectClass = params;
  }

  refresh(params: any): boolean {
    this.params.dataSource = params.dataSource;
    return true;
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/render/grid-select-renderer.component.ts